import {
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  OnChanges,
  SimpleChanges,
  TemplateRef,
  QueryList
} from '@angular/core';

import {
  SkyGridColumnHeadingModelChange
} from './types';


export class SkyGridColumnComponent implements OnChanges {
  
  public id: string;

  
  public heading: string;

  
  public width: number;

  
  public hidden: boolean;

  
  public locked: boolean;

  
  public field: string;

  
  public type: string;

  
  public description: string;

  
  public isSortable: boolean = true;

  /* tslint:disable:no-input-rename */
  
  public searchFunction: (value: any, searchText: string) => boolean = this.search;

  
  public templateInput: TemplateRef<any>;
  /* tslint:enable:no-input-rename */

  public headingChanges: EventEmitter<string> = new EventEmitter<string>();
  public headingModelChanges = new EventEmitter<SkyGridColumnHeadingModelChange>();

  
  private templates: QueryList<TemplateRef<any>>;

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.heading && changes.heading.firstChange === false) {
      this.headingChanges.emit(this.heading);
      this.headingModelChanges.emit({
        value: this.heading,
        id: this.id,
        field: this.field
      });
    }
  }

  public get template(): TemplateRef<any> {
    if (this.templates.length > 0) {
      return this.templates.first;
    }

    return this.templateInput;
  }

  private search(value: any, searchText: string): boolean {
    /* tslint:disable:no-null-keyword */
    if (value !== undefined && value !== null) {
      return value.toString().toLowerCase().indexOf(searchText) !== -1;
    }
    /* tslint:enable */

    return false;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-grid-column',
  template: '<ng-content></ng-content>',
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'id': [{ type: Input },],
'heading': [{ type: Input },],
'width': [{ type: Input },],
'hidden': [{ type: Input },],
'locked': [{ type: Input },],
'field': [{ type: Input },],
'type': [{ type: Input },],
'description': [{ type: Input },],
'isSortable': [{ type: Input },],
'searchFunction': [{ type: Input, args: ['search', ] },],
'templateInput': [{ type: Input, args: ['template', ] },],
'templates': [{ type: ContentChildren, args: [TemplateRef, ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
